import { css, globalCSS } from 'omi';

import styles from '../../_common/style/web/components/switch/_index.less';

export const styleSheet = css`
  ${styles}
`;

globalCSS(styleSheet);
